const transitions = {
  transition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'oTransitionEnd otransitionend',
};

let transitionEvent;
if (typeof window !== 'undefined') {
  const { style } = document.createElement('div');
  const keys = Object.keys(transitions);
  for (let i = 0, key = keys[i]; i < keys.length; i += 1, key = keys[i]) {
    if (key in style) {
      transitionEvent = transitions[key];
      break;
    }
  }
}

/**
 * Handles transition end event by demand. It removes the handler once the animation ends
 * or once the fallback timeout expires in case the animation fails
 * @param {HTMLElement} element - Element to handle its animation transition
 * @param {Function} callback - Function to callback after animation ends or timeout expires
 * @param {Number} fallback - Milliseconds used as fallback for timeout
 */
export default (element, callback, fallback) => {
  element.addEventListener(transitionEvent, callback);
  let removed = false;
  const removeListener = () => {
    if (removed) return;
    element.removeEventListener(transitionEvent, callback);
    removed = true;
  };
  const timeout = setTimeout(callback, fallback + 16);
  return () => {
    removeListener();
    clearTimeout(timeout);
  };
};
